import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { useState } from 'react'
import { Typography, Icon, Button, DropdownContent, Dropdown } from 'shared/ui'
import styles from './styles.module.scss'

type ICustomPlanCardProps = {
  onChatWithSales: () => void
  onBookMeeting: () => void
  onShowGetCallModal: () => void
}

export const CustomPlanCard = observer(
  ({ onChatWithSales, onBookMeeting, onShowGetCallModal }: ICustomPlanCardProps) => {
    const [isActiveDropdown, setActiveDropdown] = useState(false)

    return (
      <div className={classNames(styles.planInfo, styles.recommendedPlanInfo, styles.greenBorder)}>
        <Icon icon='arrow_09' fontSize={72} className={styles.arrowIcon} />

        <Typography ariaLabel='opportunity_modal_custom_plan_title' variant='body-lg-semibold'>
          Custom plan
        </Typography>
        <div className={styles.getBetterDeal}>
          <Typography
            ariaLabel='opportunity_modal_get_better_deal'
            variant='body-md-medium'
            color='var(--green-100)'
          >
            Get a better deal
          </Typography>
        </div>
        <Typography
          ariaLabel='opportunity_modal_speak_to_sales_title'
          variant='body-xl-semibold'
          tag='div'
          width='245px'
          marginBottom={16}
        >
          Want to speak to sales?
        </Typography>
        <Typography
          ariaLabel='opportunity_modal_speak_to_sales_description'
          variant='body-rg-regular'
          tag='div'
          marginBottom={26}
          marginTop={28}
        >
          Based on your current usage, upgrading to a custom plan could save you more and offer
          predictable costs. Let&apos;s chat to find the best solution for your needs!
        </Typography>
        <Dropdown
          ariaLabel='ConnectWithSalesDropdown'
          className={styles.connectWithSalesDropdown}
          show={isActiveDropdown}
          onChangeOpen={setActiveDropdown}
          placement='top'
          triggerComponent={() => (
            <Button
              text='Connect with sales'
              typeBtn='contained'
              contained='primary'
              size='large'
              className={styles.chatWithSalesButton}
              fullWidth
              iconRight={isActiveDropdown ? 'chevronUp' : 'chevronDown'}
              onClick={() => setActiveDropdown(!isActiveDropdown)}
            />
          )}
          customComponent={() => (
            <DropdownContent noPadding width={296}>
              <div className={styles.dropdownList}>
                <Button
                  icon={'calendarPlus2'}
                  text='Book a meeting'
                  typeBtn='menuItem'
                  onClick={() => {
                    setActiveDropdown(false)
                    onBookMeeting()
                  }}
                />
                <Button
                  id='intercom-custom-plan_modal-button'
                  icon={'conversation'}
                  text='Start a chat'
                  typeBtn='menuItem'
                  onClick={() => {
                    setActiveDropdown(false)
                    onChatWithSales()
                  }}
                />
                <Button
                  icon={'phoneIncomingCall'}
                  text='Get a call'
                  typeBtn='menuItem'
                  onClick={() => {
                    setActiveDropdown(false)
                    onShowGetCallModal()
                  }}
                />
              </div>
            </DropdownContent>
          )}
        />
      </div>
    )
  }
)
